import { render, staticRenderFns } from "./home-bg-image.vue?vue&type=template&id=2c1f3a56&scoped=true&"
import script from "./home-bg-image.vue?vue&type=script&lang=js&"
export * from "./home-bg-image.vue?vue&type=script&lang=js&"
import style0 from "./home-bg-image.vue?vue&type=style&index=0&id=2c1f3a56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f3a56",
  null
  
)

export default component.exports